module.exports = __webpack_public_path__ + "img/teacherBg.4fa7e763.png";